import { BaseApi as Base } from '@micromag/data';

class AnalyticsApi extends Base {
    organisationSummary(query = {}) {
        const finalQuery = {
            ...query,
        };
        return this.requestGet(this.route('organisations.stats'), finalQuery);
    }

    storySummary(storyId, query = {}) {
        const finalQuery = {
            ...query,
        };
        return this.requestGet(
            this.route('organisations.stats.story', { story: storyId }),
            finalQuery,
        );
    }

    screenSummary(storyId, screenId, query = {}) {
        const finalQuery = {
            ...query,
        };
        return this.requestGet(
            this.route('organisations.stats.screen', { story: storyId, screen: screenId }),
            finalQuery,
        );
    }

    // Think about this one
    screenEvents(storyId, screenId, query = {}) {
        const finalQuery = {
            ...query,
        };
        return this.requestGet(
            this.route('organisations.stats.screen.events', { story: storyId, screen: screenId }),
            finalQuery,
        );
    }
}

export default AnalyticsApi;
